// Libraries
var React = require('react');
var $ = require('jquery');
var orderBy = require('lodash/orderBy');
var PubSub = require('pubsub-js');

// Components
var CommentaryComment = require("./CommentaryComment");
var LoadMore = require('LoadMore/LoadMore');

// Assets
var spinner = require('images/Rolling.svg');

// Styles
require('./CommentaryModule.scss');

class CommentaryModule extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			allData: [],
			visibleData: [],
			commentatorName: "",
			isLoading: true,
			isMore: false
		};

		this.pageSize = 10;
		this.currentPage = 1;
		this.pages = 0;
	}

	componentDidMount() {
		// delay the load of the realtime library until it's reached the browser 
		// to avoid server side rendering errors
		this.Realtime = require('Realtime/Realtime');

		$.ajax({
			method: "GET",
			url: this.props.data.endpoints[0].url
		})
		.done((data) => {
			let allData = data.commentaryEvents;

			this.pages = Math.ceil(allData.length / this.pageSize);
			let visibleData = allData.slice(0, this.pageSize);

			this.setState({
				allData,
				visibleData,
				commentatorName: data.commentatorName,
				isLoading: false,
				isMore: visibleData.length < allData.length
			});
		})
		.fail(() => {
			this.setState({ isLoading: false });
		});

		window.addEventListener('scroll', this.scrollHandler);

		this.attachChannels();
	}

	handleLoadMore = () => {
		this.currentPage++;

		let dataPaged = this.state.allData.slice(0, (this.currentPage * this.pageSize));

		this.setState({
			visibleData: dataPaged,
			pages: Math.ceil(this.state.allData.length),
			isMore: dataPaged.length !== this.state.allData.length,
			isLoading: false
		});
	};

	scrollHandler = () => {
		const rect = this.commentary.getBoundingClientRect();
		if (window.innerHeight > rect.bottom && !this.state.isLoading && rect.bottom > 0) {
			this.setState({
				isLoading: true,
			}, () => {
				this.handleLoadMore();
			});
		}
	};

	updateCommentary = (commentary) => {
		//handle case where item may already exist, and is being updated
		let itemToRemove = commentary[0].Id;
		
		// if we have an update, remove pre-existing items that are 'AdminComments' as here we get highlights coming which all have an index of 0
		let filteredAllData = this.state.allData.filter(item => item.HighlightSource !=='AdminComment' || item.Id !== itemToRemove);

		// add new item to the full set of data
		//let allDataModified = this.state.allData.concat(commentary);
		let allDataModified = filteredAllData.concat(commentary);

		// order by timestamp
		allDataModified = orderBy(allDataModified, [function(obj) { return obj.TimeStamp; }], ['desc']);

		// re-page the visible data
		let amountToView = this.currentPage * this.pageSize;
		let visibleDataModified = allDataModified.slice(0, amountToView >= allDataModified.length ? allDataModified.length : amountToView);

		this.setState({
			allData: allDataModified,
			visibleData: visibleDataModified,
			isMore: visibleDataModified.length < allDataModified.length
		}, () => {
			if (window.twttr) {
				window.twttr.widgets.load();
			}
		});

		PubSub.publish('IndicatorChange', { tabId: this.props.tabId, hasIndicator: true });
	};

	deleteCommentary = (commentary) => {

		// remove all items that have the Ids passed in
		let allDataModified = this.state.allData.slice().filter(x => commentary.findIndex(y => y === x.Id) === -1);
		
		// re-page the visible data
		let amountToView = this.currentPage * this.pageSize;
		let visibleDataModified = allDataModified.slice(0, amountToView >= allDataModified.length ? allDataModified.length : amountToView);

		this.setState({
			allData: allDataModified,
			visibleData: visibleDataModified,
			isMore: visibleDataModified.length < allDataModified.length
		}, () => {
			if (window.twttr) {
				window.twttr.widgets.load();
			}
		});
	};

	attachChannels() {
		let commentaryChannel = this.props.data.endpoints.find(x => x.name === "highlightsAndCommentary").channelId;

		this.Realtime.subscribe(commentaryChannel, this.props.data.realtimeKey, (message) => {
			if (message.data.Deleted.length > 0) {
				console.debug("------ CommentaryModule - delete data received ------");
				console.debug(message.data.Deleted);
				this.deleteCommentary(message.data.Deleted);
			}
			if (message.data.Updated.length > 0) {
				console.debug("------ CommentaryModule - update data received ------");
				console.debug(message.data.Updated);
				this.updateCommentary(message.data.Updated);
			}
		});
	}

	render() {
		return (
			<div className="Commentary"  ref={comments => this.commentary = comments}>
				{!this.state.isLoading && this.state.visibleData.length > 0 &&
					<div className="Commentary__title">
						<h2>Live Reporting</h2> 
						<p>By {this.state.commentatorName}</p>
					</div>
				}

				<div className="Commentary__wrapper">
					{this.state.visibleData.length > 0 &&
						this.state.visibleData.map((comment, index) => <CommentaryComment isHomeTeam={comment.IsHomeTeam} homeTeamCrestUrl={this.props.data.homeTeamCrestUrl} awayTeamCrestUrl={this.props.data.awayTeamCrestUrl} comment={comment} key={index} baseUrl={this.props.data.baseUrl} />)
					}
				</div>

				{this.state.isMore &&
					<LoadMore handle={this.handleLoadMore} caption="Show more" context="commentary"/>
				}

				{this.state.isLoading &&
					<img src={spinner} className="spinner" alt="Loading..." />
				}

				{!this.state.isLoading && this.state.visibleData.length === 0 &&
					<p>Live text commentary will start on this page in the build-up to kick-off.</p>
				}
			</div>
		)
	}
}

module.exports = CommentaryModule;



// WEBPACK FOOTER //
// ./src/components/MDC/Commentary/CommentaryModule.js